<h2>{{ title }}</h2>
<p [innerText]="message"></p>
<a routerLink="/">Go back to home</a>
